import * as React from "react";
import Template from "../../../../core/libraries/Template";
import { connect } from "react-redux";
import { RootState } from "../../../../store/store";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import Helper from "../../../../core/libraries/Helper";
import Constants from "../../../../core/libraries/Constants";
import { updateProperty } from "../../actions";
import DatePicker from "../../../../core/components/DatePickerWithErrorController";
import { ReportStatus } from "../../types";
import RbLabel from "../../../../bosch-react/components/label/RbLabel";
import RbTextField from "../../../../bosch-react/components/text-field/RbTextField";
import RbRadio from "../../../../bosch-react/components/radio/RbRadio";
import { IDynamicPerson, } from "@microsoft/mgt-react";
import CustomizedPeoplePicker from "../../../../core/components/PeoplePicker/CustomizedPeoplePicker";
import { PrincipalType } from "../../../../core/components/PeoplePicker/types";
import { addAliasDomain, removeAliasDomain } from "../../../../utils/converter";

interface RightColumnProps {
  report: any;
  validation: any;
  mode: string;
  status: string;
  securityClasses: any[];
  documentTypes: any[];
  updateProperty: typeof updateProperty;
  // from parent
  hasAdminPermission: boolean | undefined;
}

class RightColumn extends React.Component<RightColumnProps, any> {
  additionalApproversRef: React.RefObject<any> = React.createRef();
  notificationUsersRef: React.RefObject<any> = React.createRef();
  notifyToRef: React.RefObject<any> = React.createRef();
  authorizedAssociatesRef: React.RefObject<any> = React.createRef();
  organizationalUnitsRef: React.RefObject<any> = React.createRef();
  customACLRef: React.RefObject<any> = React.createRef();

  constructor(props: RightColumnProps) {
    super(props);
    this.renderRelevantForForeignTradeLegistation =
      this.renderRelevantForForeignTradeLegistation.bind(this);
    this.renderSecurityClass = this.renderSecurityClass.bind(this);
    this.renderReportType = this.renderReportType.bind(this);
    this.renderDocumentNumber = this.renderDocumentNumber.bind(this);
    this.renderProjectNumber = this.renderProjectNumber.bind(this);
    this.renderPlantBU = this.renderPlantBU.bind(this);
    this.renderProduct = this.renderProduct.bind(this);
    this.renderProcess = this.renderProcess.bind(this);
    this.renderIQISNumber = this.renderIQISNumber.bind(this);
    this.renderNameOfConference = this.renderNameOfConference.bind(this);
    this.renderLocationOfConference =
      this.renderLocationOfConference.bind(this);
    this.renderDateOfConference = this.renderDateOfConference.bind(this);
    this.renderNameOfJournal = this.renderNameOfJournal.bind(this);
    this.renderDateOfPublication = this.renderDateOfPublication.bind(this);
    this.renderAbstract = this.renderAbstract.bind(this);
    this.renderAdditionalApprovers = this.renderAdditionalApprovers.bind(this);
    this.renderNotificationUsers = this.renderNotificationUsers.bind(this);
    this.renderAuthorizedAssociates =
      this.renderAuthorizedAssociates.bind(this);
    this.renderOrganizationalUnits = this.renderOrganizationalUnits.bind(this);
    this.renderCustomACL = this.renderCustomACL.bind(this);
    this.renderComment = this.renderComment.bind(this);
  }

  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg0 ms-xl1" />
          <div className="ms-Grid-col ms-lg12 ms-xl11">
            {this.renderRelevantForForeignTradeLegistation()}
            {this.renderSecurityClass()}
            {this.renderContentType()}
            {this.renderReportType()}
            {this.renderDocumentNumber()}
            {this.renderProjectNumber()}
            {this.renderPlantBU()}
            {this.renderProduct()}
            {this.renderProcess()}
            {this.renderIQISNumber()}
            {this.renderNameOfConference()}
            {this.renderLocationOfConference()}
            {this.renderDateOfConference()}
            {this.renderNameOfJournal()}
            {this.renderDateOfPublication()}
            {this.renderAbstract()}
            {this.renderAdditionalApprovers()}
            {this.renderNotificationUsers()}
            {this.renderAuthorizedAssociates()}
            {this.renderOrganizationalUnits()}
            {this.renderCustomACL()}
            {this.renderComment()}
          </div>
        </div>
      </div>
    );
  }

  renderRelevantForForeignTradeLegistation() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Report contains export controlled material",
        <RbRadio
          defaultValue={this.props.report.relForForeignTradeLegislation}
          itemWidth={5}
          isHorizontal={true}
          items={[
            { value: true, label: "Yes", disabled: true },
            { value: false, label: "No", disabled: true },
          ]}
        />,
        <RbRadio
          defaultValue={this.props.report.relForForeignTradeLegislation}
          itemWidth={5}
          isHorizontal={true}
          items={[
            {
              value: true,
              label: "Yes",
              disabled: this.props.status === ReportStatus.PUBLISHED,
            },
            {
              value: false,
              label: "No",
              disabled: this.props.status === ReportStatus.PUBLISHED,
            },
          ]}
          onChange={(selectedValue) => {
            this.props.updateProperty(
              "relForForeignTradeLegislation",
              selectedValue
            );
            if (selectedValue === true) {
              this.props.updateProperty(
                "securityClass",
                Constants.SECURITY_CLASS_SHORT_NAME.SC3
              );
            }
            this.forceUpdate();
          }}
        />
      );
    }
    return null;
  }

  renderSecurityClass() {
    let scOptions: IDropdownOption[] = this.props.securityClasses;
    if (this.props.report.relForForeignTradeLegislation) {
      scOptions = scOptions.map((sc) => {
        return {
          ...sc,
          disabled: sc.key !== Constants.SECURITY_CLASS_SHORT_NAME.SC3,
        };
      });
    } else {
      scOptions = scOptions.map((sc) => {
        return { ...sc, disabled: sc.key === "" };
      });
    }
    return Template.renderAccessMediatorRowTemplate(
      this.props.mode,
      "Security class",
      <span className="textarea-transparent">
        <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
          {Helper.getSCLongName(this.props.report.securityClass)}
        </RbLabel>
      </span>,
      <Dropdown
        selectedKey={this.props.report.securityClass}
        placeholder="Choose a report type ..."
        options={scOptions}
        onChange={(event, option: IDropdownOption | undefined) => {
          this.props.updateProperty(
            "securityClass",
            option?.key !== "" ? option?.key : null
          );
          this.forceUpdate();
        }}
        disabled={this.props.status === ReportStatus.PUBLISHED}
        errorMessage={Helper.setEmptyIfNull(
          this.props.validation.securityClass
        )}
      />
    );
  }

  renderContentType() {
    const contentType = <span className="textarea-transparent">
      <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
        {this.props.report.uploadTypeDescription}
      </RbLabel>
    </span>
    return Template.renderAccessMediatorRowTemplate(
      this.props.mode,
      "Content type",
      contentType,
      contentType
    );
  }

  renderReportType() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD ||
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Thesis ||
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Report type",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.documentType}
          </RbLabel>
        </span>,
        <Dropdown
          selectedKey={this.props.report.documentType}
          placeholder="Choose a report type ..."
          options={this.props.documentTypes}
          onChange={(event, option: IDropdownOption | undefined) => {
            this.props.updateProperty("documentType", option?.key);
            this.forceUpdate();
          }}
          errorMessage={Helper.setEmptyIfNull(
            this.props.validation.documentType
          )}
        />
      );
    }
    return null;
  }

  renderDocumentNumber() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Report number",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.documentNumber}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.documentNumber}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty(
              "documentNumber",
              event.currentTarget.value
            );
          }}
        />,
        null,
        Helper.setEmptyIfNull(this.props.validation.documentNumber),
        true
      );
    }
    return null;
  }

  renderProjectNumber() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Project number",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.projectNumber}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.projectNumber}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty(
              "projectNumber",
              event.currentTarget.value
            );
          }}
        />,
        null,
        Helper.setEmptyIfNull(this.props.validation.projectNumber),
        true
      );
    }
    return null;
  }

  renderPlantBU() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.LL) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Plant/Business unit",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.plantorBu}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.plantorBu}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("plantorBu", event.currentTarget.value);
          }}
        />,
        Helper.setEmptyIfNull(this.props.validation.plantorBu)
      );
    }
    return null;
  }

  renderProduct() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.LL) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Product",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.product}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.product}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("product", event.currentTarget.value);
            this.forceUpdate();
          }}
          disabled={
            Helper.setEmptyIfNull(this.props.report.process).trim() !== ""
          }
        />,
        Helper.setEmptyIfNull(this.props.validation.product)
      );
    }
    return null;
  }

  renderProcess() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.LL) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Process",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.process}
          </RbLabel>{" "}
        </span>,
        <RbTextField
          value={this.props.report.process}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("process", event.currentTarget.value);
            this.forceUpdate();
          }}
          disabled={
            Helper.setEmptyIfNull(this.props.report.product).trim() !== ""
          }
        />,
        Helper.setEmptyIfNull(this.props.validation.process)
      );
    }
    return null;
  }

  renderIQISNumber() {
    if (this.props.report.uploadType === Constants.UPLOAD_TYPE.LL) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "IQIS number",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.iqisnumber}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.iqisnumber}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("iqisnumber", event.currentTarget.value);
          }}
        />,
        null,
        Helper.setEmptyIfNull(this.props.validation.iqisnumber),
        true
      );
    }
    return null;
  }

  renderNameOfConference() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
      this.props.report.documentType === "Conference Paper"
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Name of conference",
        <span className="textarea-transparent">
          <RbLabel>{this.props.report.nameOfConference}</RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.nameOfConference}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty(
              "nameOfConference",
              event.currentTarget.value
            );
          }}
        />,
        Helper.setEmptyIfNull(this.props.validation.nameOfConference)
      );
    }
    return null;
  }

  renderLocationOfConference() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
      this.props.report.documentType === "Conference Paper"
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Location of conference",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.locationOfConference}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.locationOfConference}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty(
              "locationOfConference",
              event.currentTarget.value
            );
          }}
        />,
        Helper.setEmptyIfNull(this.props.validation.locationOfConference)
      );
    }
    return null;
  }

  renderDateOfConference() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
      this.props.report.documentType === "Conference Paper"
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Date of conference",
        <span className="textarea-transparent">
          <RbLabel hasPadding={true}>
            {Helper.getDateTimeFormatForUI(this.props.report.dateOfConference)}
          </RbLabel>
        </span>,
        <DatePicker
          value={Helper.parseDate(this.props.report.dateOfConference)}
          onSelectDate={(date: Date) => {
            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            this.props.updateProperty("dateOfConference", utcDate);
          }}
          errorMessage={this.props.validation.dateOfConference}
        />
      );
    }
    return null;
  }

  renderNameOfJournal() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
      this.props.report.documentType === "Journal Paper"
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Name of journal",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.nameOfJournal}
          </RbLabel>
        </span>,
        <RbTextField
          value={this.props.report.nameOfJournal}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty(
              "nameOfJournal",
              event.currentTarget.value
            );
          }}
        />,
        Helper.setEmptyIfNull(this.props.validation.nameOfJournal)
      );
    }
    return null;
  }

  renderDateOfPublication() {
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
      this.props.report.documentType === "Journal Paper"
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Date of publication",
        <span className="textarea-transparent">
          <RbLabel hasPadding={true}>
            {Helper.getDateTimeFormatForUI(this.props.report.dateOfPublication)}
          </RbLabel>
        </span>,
        <DatePicker
          value={Helper.parseDate(this.props.report.dateOfPublication)}
          onSelectDate={(date: Date) => {
            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            this.props.updateProperty("dateOfPublication", utcDate);
          }}
          errorMessage={this.props.validation.dateOfPublication}
        />
      );
    }
    return null;
  }

  renderAbstract() {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Abstract",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.abstract}
          </RbLabel>
        </span>,
        <RbTextField
          isMultiple={true}
          minRows={2}
          value={this.props.report.abstract} //Previous minRows={5}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("abstract", event.currentTarget.value);
          }}
        />,
        Helper.setEmptyIfNull(this.props.validation.abstract)
      );
  }

  onChangeAdditionalApprovers(event: any) {
    let items = this.additionalApproversRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty("additionalApprovers", results);
  }

  renderAdditionalApprovers() {
    return Template.renderAccessMediatorRowTemplate(
      this.props.mode,
      "Additional approvers",
      Template.renderReadOnlyPeople(
        this.props.report.additionalApprovers
      ),
      // <PeoplePicker type={PersonType.person} defaultSelectedUserIds={["hsy1hc"]} selectionChanged={(event) => this.onChangeAuthorizedAssociates(event)} />
      <CustomizedPeoplePicker
        componentRef={this.additionalApproversRef}
        principalType={PrincipalType.People}
        objectIds={this.props.report.additionalApprovers}
        onChange={(event: any) => this.onChangeAdditionalApprovers(event)} />,
      null,
      Helper.setEmptyIfNull(this.props.validation.additionalApprovers),
      true
    );
  }


  onChangeNotificationUsers(event: CustomEvent<IDynamicPerson[]>): void {
    let items = this.notificationUsersRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty("notificationUsers", results);
  }

  renderNotificationUsers() {
    let notificationUsers = this.props.report.notificationUsers
    if (
      this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD ||
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Thesis ||
      this.props.report.uploadType === Constants.UPLOAD_TYPE.Paper
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Notify to",
        Template.renderReadOnlyPeople(
          notificationUsers
        ),
        <CustomizedPeoplePicker
          componentRef={this.notificationUsersRef}
          principalType={PrincipalType.People}
          objectIds={notificationUsers}
          onChange={(event: any) => this.onChangeNotificationUsers(event)} />,
        null,
        undefined,
        true
      )
    }
    return null;
  }


  onChangeAuthorizedAssociates(event: CustomEvent<IDynamicPerson[]>): void {
    let items = this.authorizedAssociatesRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty("authorizedAssociates", results);
  }

  renderAuthorizedAssociates() {
    let authorizedAssociates = this.props.report.authorizedAssociates
    if (
      this.props.hasAdminPermission === true ||
      (this.props.status !== ReportStatus.PUBLISHED &&
        this.props.mode === "Edit")
    ) {
      if (
        (this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD ||
          this.props.report.uploadType === Constants.UPLOAD_TYPE.Thesis) &&
        this.props.report.securityClass !== Constants.SECURITY_CLASS_SHORT_NAME.SC1
      ) {
        return Template.renderAccessMediatorRowTemplate(
          this.props.mode,
          "Authorized associates",
          Template.renderReadOnlyPeople(
            authorizedAssociates
          ),
          // <PeoplePicker type={PersonType.person} defaultSelectedUserIds={["hsy1hc"]} selectionChanged={(event) => this.onChangeAuthorizedAssociates(event)} />,
          <CustomizedPeoplePicker
            componentRef={this.authorizedAssociatesRef}
            principalType={PrincipalType.People}
            objectIds={authorizedAssociates}
            onChange={(event: any) => this.onChangeAuthorizedAssociates(event)} />,
          null,
          Helper.setEmptyIfNull(this.props.validation.authorizedAssociates),
          true
        );
      }
    }
    return null;
  }

  onChangeOrganizationalUnits = (event: CustomEvent<IDynamicPerson[]>) => {
    let items = this.organizationalUnitsRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.id && results.push(removeAliasDomain(item.id));
    });
    this.props.updateProperty("organizationalUnits", results);
  }
  renderOrganizationalUnits() {
    let orgUnits = this.props.report.organizationalUnits
    if (
      this.props.hasAdminPermission === true ||
      (this.props.status !== ReportStatus.PUBLISHED &&
        this.props.mode === "Edit")
    ) {
      if (
        this.props.report.securityClass ===
        Constants.SECURITY_CLASS_SHORT_NAME.SC2 &&
        (this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD ||
          this.props.report.uploadType === Constants.UPLOAD_TYPE.Thesis)
      ) {
        return Template.renderAccessMediatorRowTemplate(
          this.props.mode,
          "Organizational units",
          Template.renderReadOnlyGroup(
            orgUnits
          ),
          <CustomizedPeoplePicker
            componentRef={this.organizationalUnitsRef}
            principalType={PrincipalType.Group}
            objectIds={orgUnits}
            onChange={(event: any) => this.onChangeOrganizationalUnits(event)} />,
          null,
          undefined,
          true
        );
      }
    }
    return null;
  }

  onChangeCustomACL = (event: CustomEvent<IDynamicPerson[]>) => {
    let items = this.customACLRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty("customAcl", results);
  }

  renderCustomACL() {
    let customACL = this.props.report.customAcl as string[];
    if (customACL === undefined || customACL === null) {
      customACL = [];
    }
    const groupIds = customACL.filter(item => item.length === 36)
    const peopleIds = customACL.filter(item => item.length !== 36)
    if (
      this.props.hasAdminPermission === true &&
      this.props.status === ReportStatus.PUBLISHED &&
      this.props.report.securityClass !== Constants.SECURITY_CLASS_SHORT_NAME.SC1
    ) {
      if (
        this.props.report.uploadType === Constants.UPLOAD_TYPE.RnD ||
        this.props.report.uploadType === Constants.UPLOAD_TYPE.Thesis
      ) {
        return Template.renderAccessMediatorRowTemplate(
          this.props.mode,
          "CustomACL",
          <>
            {!!groupIds && groupIds.length > 0 && Template.renderReadOnlyGroup(groupIds)}
            {!!peopleIds && peopleIds.length > 0 && Template.renderReadOnlyPeople(peopleIds)}
          </>,
          <>
            {!!groupIds && groupIds.length > 0 && Template.renderReadOnlyGroup(groupIds)}
            {!!peopleIds && peopleIds.length > 0 && Template.renderReadOnlyPeople(peopleIds)}
          </>
        );
      }
    }
    return null;
  }

  renderComment() {
    if (
      this.props.status !== ReportStatus.PUBLISHED &&
      this.props.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.mode,
        "Comment",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {this.props.report.Comment}
          </RbLabel>
        </span>,
        <RbTextField
          minRows={5}
          maxRows={8}
          isMultiple={true}
          value={this.props.report.Comment}
          placeholder="If there is any further information you want to tell the approvers before reviewing your document, you can let them know here."
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("comment", event.currentTarget.value);
          }}
        />,
        null,
        "",
        true,
        "(Optional – will only be seen by the approvers)"
      );
    }
    return null;
  }
}

const mapStateToProps = (state: RootState) => ({
  report: state.accessMediator.report,
  validation: state.accessMediator.validation,
  mode: state.accessMediator.mode,
  status: state.accessMediator.status,
  securityClasses: state.accessMediator.securityClasses,
  documentTypes: state.accessMediator.documentTypes,
});

export default connect(mapStateToProps, {
  updateProperty,
})(RightColumn);
